export function noOp() {}
export function nullFunct() {
  return null;
}
